//MainMenu.tsx =============================================================
//Tools > Options > Text Editor > JavaScript/TypeScript > Language Service...
//Uncheck 'Enable the new JavaScript language service'.
//https://risingstars.js.org/2017/en/
//https://www.robinwieruch.de/essential-react-libraries-framework/
//https://material-ui.com/style/typography/ - For font style choices.
//http://flexbox.buildwithreact.com/    Flexbox code generator.
import "../Util/Prototypes";

import * as Custom from "../Custom";
import * as Default from "../Default";
import * as DrawerMenu from "./DrawerMenu";
import * as GetSearchResults from "../Search/GetSearchResults";
import * as PrevTool from "./PrevTool";
import * as QueryString from "../QueryString";
import * as Settings from "../Settings";
import * as Spinner from "../Util/Spinner";
import * as Splash from "../Splash";
import * as Util from "../Util/Util";

import { Button, CssBaseline, Icon } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React from "react";
import ReactDOM from "react-dom/client";

let root: ReactDOM.Root;
let root2: ReactDOM.Root;

//Render all components in the html content div.
export function render() {
   Util.logMsg('Building MainMenu react components.');

   if (!root) {
      root = ReactDOM.createRoot(document.getElementById("mainMenuDiv"));
   }
   root.render(<MainMenuComponent />);

   if (!root2) {
      root2 = ReactDOM.createRoot(document.getElementById("spinner_div"));
   }
   root2.render(<Spinner.Render />);
}

// Main menu component. =======================================================
interface iProps {
}

function MainMenuComponent(props: iProps) {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   function showDrawer() {
      DrawerMenu.classRef.show();
   }

   function logoClick() {
      Custom.openLink("Home");
   }

   //Component did mount.
   React.useEffect(() => {
      Util.logMsg('MainMenu did mount');

      //Process pin and address query string arguments.
      if (QueryString.pin) {
         setTimeout(function () {
            GetSearchResults.init(QueryString.pin);
            QueryString.setPIN(null);
         }, 2000);

      } else if (QueryString.address) {
         setTimeout(function () {
            GetSearchResults.init(null, QueryString.address);
            QueryString.setAddress(null);
         }, 2000);
      }
   }, []);

   //Component did update.
   React.useEffect(() => {
   });

   Util.logMsg('Rendering MainMenu.tsx react components.');
   //<span style={{ 'fontSize': '10pt', 'color': 'darkgreen', 'textShadow': '2px 2px 4px silver' }}>Agency Name</span>
   const styles: Default.iStyles = {
      button: { paddingLeft: 5, paddingRight: 5, borderRadius: 2 },
      seal: { padding: 0, paddingLeft: 12, paddingRight: 12, backgroundColor: 'gainsboro', borderRadius: 0 },
   };

   return (
      <ThemeProvider theme={Default.theme}>
         <CssBaseline />

         <Button style={styles.button} variant="contained" size="medium" color="primary" onClick={showDrawer} title="Menu">
            <Icon style={{ fontSize: 24 }}>menu</Icon>
         </Button>

         <Button style={styles.seal} variant="contained" size="medium" color="primary" onClick={logoClick} title="Home" >
            <img src={Settings.webSiteLogo} height="36px" alt="Logo" />
         </Button>

         <PrevTool.Build />
         <DrawerMenu.Build />

         {(Settings.security.accessLevel < Settings.splashScreenHideLevel) &&
            <Splash.Render />
         }
      </ThemeProvider>
   ); //end return.

} //end function.
